import SEO from "../../../data/seo";
import HeaderTwo from "../../../layout/headers/header-two";
import BreadCrumb from "../../common/breadcrumb";
import TeamMain from "./team";
import FooterTwo from "../../../layout/footers/footer-two";

const TeamPageTwo = () => {
    return (
        <>
            <SEO pageTitle="Team"/>
            <HeaderTwo/>
            <BreadCrumb title="Company Organizational Structure" items={[
                {label: "Team"}
            ]}/>
            <TeamMain/>
            <FooterTwo/>
        </>
    );
};

export default TeamPageTwo;